import React from 'react';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper, { PopperPlacementType } from '@material-ui/core/Popper';

import createStyles from '@material-ui/core/styles/createStyles';
import {Paper} from "@material-ui/core";

const styles = () => createStyles({
  root: {
    zIndex: 1001,
  },
  children: {
    display: 'flex',
    flexDirection: 'column',
  },
});

interface Props extends WithStyles<typeof styles> {
  anchorEl: any;
  open: boolean;
  onClose: () => void;
  placementOverride?: PopperPlacementType;
}

class ActionBarMenu extends React.Component<Props> {
  render() {
    const {
      classes, anchorEl, open, onClose, children, placementOverride,
    } = this.props;
    const menuPlacement = placementOverride || 'bottom-start';
    return (
      <Popper
        className={classes.root}
        open={open}
        anchorEl={anchorEl}
        placement={menuPlacement}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            {...placement}
          >
            <Paper>
              <ClickAwayListener onClickAway={onClose}>
                <div className={classes.children}>
                  {children}
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    );
  }
}

export default withStyles(styles)(ActionBarMenu);
